import { render, staticRenderFns } from "./CommodityMarketingDiscussReview.vue?vue&type=template&id=da961a0a&scoped=true&"
import script from "./CommodityMarketingDiscussReview.vue?vue&type=script&lang=js&"
export * from "./CommodityMarketingDiscussReview.vue?vue&type=script&lang=js&"
import style0 from "./CommodityMarketingDiscussReview.vue?vue&type=style&index=0&id=da961a0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da961a0a",
  null
  
)

export default component.exports